export const getFilter = (state) => state.filters.filter
export const hasFilter = (state) => state.filters.filter !== 'all'
export const getCarePlanFilter = (state) => state.filters.excludedCarePlans
export const getAsideState = (state) => state.filters.isOpen
